import AnalisaBarangJadi from './AnalisaBarangJadi';

export default AnalisaBarangJadi;
